<template>
  <b-container fluid class="pt-4 px-5" v-if="$store.state.form.actualFormConfig">
    <b-tabs content-class="mt-3" pills card>
      <b-tab :title="labels.permissions" active>
        <form-permissions></form-permissions>
      </b-tab>
      <b-tab :title="labels.publicSurvey">
        <public-survey></public-survey>
      </b-tab>
      <b-tab :title="labels.otherSettings">
        <other-settings></other-settings>
      </b-tab>
    </b-tabs>
  </b-container>
</template>

<script>
import FormPermissions from './adminComponents/FormPermissions.vue';
import PublicSurvey from './adminComponents/PublicSurvey.vue';
import OtherSettings from './adminComponents/OtherSettings.vue';
import base from '../_base.js';

export default {
  name: 'FormAdmin',
  mixins: [base],
  components: {
    FormPermissions,
    PublicSurvey,
    OtherSettings,
  },
  computed: {
    labels() {
      return this.$store.state.labels.form.formAdminPage;
    },
  },
};
</script>
